var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Error",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9949,0C22.3806,0.0029-0.003,22.3908,0,50.0051S22.3908,100.0029,50.0051,100 C77.6176,99.9971,100,77.6122,100,50C99.9698,22.3963,77.5989,0.0272,49.9949,0z M47.5226,24.995 c0-1.3655,1.107-2.4723,2.4723-2.4723c1.3653,0,2.4723,1.1068,2.4723,2.4723v37.856c0,1.3655-1.107,2.4723-2.4723,2.4723 c-1.3653,0-2.4723-1.1068-2.4723-2.4723V24.995z M53.1299,76.2707c-0.1859,0.4239-0.44,0.8147-0.7515,1.1571 c-0.309,0.3024-0.6802,0.5336-1.0877,0.6774c-0.405,0.1898-0.848,0.2829-1.2953,0.2719c-0.8849,0.0068-1.7371-0.3341-2.3733-0.9493 c-0.3344-0.3241-0.5915-0.7196-0.7515-1.1571c-0.1919-0.4025-0.2849-0.8449-0.2722-1.2905 c-0.0048-0.4448,0.0881-0.8855,0.2722-1.2905c0.1449-0.4239,0.405-0.799,0.7515-1.0828c0.3036-0.3268,0.6748-0.5834,1.0877-0.7516 c0.8275-0.3359,1.7534-0.3359,2.581,0c0.8155,0.3682,1.4685,1.0202,1.8391,1.8345c0.1521,0.4147,0.242,0.8496,0.2668,1.2905 c-0.0217,0.4429-0.1171,0.879-0.2819,1.2906L53.1299,76.2707z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9e583e411ea6e6a80be6d90330dc8484.svg";
export { ForwardRef as ReactComponent };